import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { PATHS } from "util/appConstants";
import Navbar from "components/Navbar";
import LightLayout from "components/Shared/LightLayout";
import {
  selectSupplierGroupsStatus,
  selectSupplierGroup,
  updateSupplierGroup,
  getSupplierGroupById,
} from "redux/slices/supplierGroupsSlice";
import { useParams } from "react-router-dom";
import SupplierGroupForm from "components/SupplierGroups/form";

const currentAction = "EDIT";
const EditSupplierGroup = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const loading = useSelector(selectSupplierGroupsStatus);
  const supplierGroup = useSelector(selectSupplierGroup);
  const { id } = useParams();

  useEffect(() => {
    if (id && !loading) {
      dispatch(getSupplierGroupById(id));
    }
  }, [dispatch, id]);

  const onSubmit = async (payload) => {
    await dispatch(updateSupplierGroup(id, payload)).then((res) =>
      res !== undefined ? history.push(PATHS.admin.supplierGroups) : ""
    );
  };

  return (
    <>
      <Navbar />
      <LightLayout doublebar loading={loading || !supplierGroup}>
        <SupplierGroupForm
          action={currentAction}
          initialValues={supplierGroup}
          onSubmit={onSubmit}
        />
      </LightLayout>
    </>
  );
};

export default EditSupplierGroup;
